var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { InitialUrlQueries, UpdateUrlQueries } from '../urlParams';
import { FilterOptions, Search } from './filterTools';
import { PageItem } from './pageItems';
export function FilterPageList(_a) {
    var items = _a.items;
    var tags = Array.from(new Set(items.flatMap(function (item) { return item.tags; })));
    var groups = Array.from(new Set(items.flatMap(function (item) { return item.group; })));
    var _b = React.useState(''), searchTerm = _b[0], setSearchTerm = _b[1];
    var _c = React.useState([]), activeTags = _c[0], setActiveTags = _c[1];
    var _d = React.useState([]), activeGroups = _d[0], setActiveGroups = _d[1];
    var _e = React.useState(items !== null && items !== void 0 ? items : []), activeItems = _e[0], setActiveItems = _e[1];
    var _f = React.useState(InitialUrlQueries()), viewingParams = _f[0], setViewingParams = _f[1];
    var itemThreshold = 12;
    var _g = React.useState(itemThreshold > items.length), showAllItems = _g[0], setShowAllItems = _g[1];
    var _h = React.useState(0), scrollY = _h[0], setScrollY = _h[1];
    var reset = function () {
        setSearchTerm('');
        setActiveTags([]);
        setActiveGroups([]);
        setViewingParams({ itemId: 0 });
    };
    var handleTags = function (tag) {
        if (activeTags.includes(tag)) {
            setActiveTags(activeTags.filter(function (tagName) { return tagName !== tag; }));
            return;
        }
        setActiveTags(__spreadArray(__spreadArray([], activeTags, true), [tag], false));
    };
    var handleGroups = function (group) {
        if (activeGroups.includes(group)) {
            setActiveGroups(activeGroups.filter(function (name) { return name !== group; }));
            return;
        }
        setActiveGroups(__spreadArray(__spreadArray([], activeGroups, true), [group], false));
    };
    var handleUrl = function (query) {
        setScrollY(window.scrollY);
        if (query.itemId === viewingParams.itemId) {
            reset();
            return;
        }
        UpdateUrlQueries(query);
        setViewingParams(query);
    };
    React.useLayoutEffect(function () {
        setScrollY(window.scrollY);
    }, []);
    React.useEffect(function () {
        // If viewing params contains an item id upon component mounting, place that item first in the array.
        if (viewingParams && viewingParams.itemId > 0) {
            // Find the index of the viewed item.
            var index_1 = items.findIndex(function (item) { return item.contentId === viewingParams.itemId; });
            if (index_1 !== -1) {
                var prioritizedItem = items.filter(function (item, i) { return i === index_1; })[0];
                items.splice(index_1, 1);
                items.unshift(prioritizedItem);
            }
        }
    }, []);
    React.useEffect(function () {
        var newItems = items
            .filter(function (item) {
            // Search in item title and description.
            return item.title.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()) ||
                item.description.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase());
        })
            .filter(function (item) {
            // Match tags.
            if (activeTags.length) {
                return item.tags.some(function (tag) { return activeTags.includes(tag); });
            }
            return item;
        });
        if (!showAllItems) {
            newItems = newItems.slice(0, itemThreshold);
        }
        setActiveItems(newItems);
    }, [searchTerm, activeTags, activeGroups, showAllItems]);
    return (React.createElement("div", { className: 'filter-page-list' },
        React.createElement("div", { className: 'filter-page-list-toolbar element-flex' },
            React.createElement(FilterOptions, { tags: tags, activeTags: activeTags, setTag: handleTags, groups: groups, activeGroups: activeGroups, setGroup: handleGroups, itemCount: activeItems.length }),
            React.createElement(Search, { term: searchTerm, setTerm: setSearchTerm })),
        React.createElement("div", { className: 'basic-grid-content element-flex results' },
            activeItems.map(function (item, index) {
                return React.createElement(PageItem, { key: "".concat(item.title, "-").concat(index++), item: item, setTag: handleTags, activeTags: activeTags, updateUrl: handleUrl, itemToggled: viewingParams.itemId === item.contentId, scrollY: scrollY, itemBlocked: viewingParams.itemId > 0 && viewingParams.itemId !== item.contentId });
            }),
            activeItems && activeItems.length === 0 &&
                React.createElement("div", null, "Hittade inga tj\u00E4nster utifr\u00E5n din filtrering.")),
        !showAllItems &&
            React.createElement("div", { className: 'empori-buttons-container align-center', onClick: function () { return setShowAllItems(true); } },
                React.createElement("span", { className: 'empori-button p-c-bgc' },
                    "Se alla ",
                    React.createElement("i", { className: 'fa-regular fa-chevron-down' })))));
}
